<template>
  <div id="user">
    <div class="inner_static">
      <div id="userspot">
        <img :src="getImage(coverPhoto)" @error="noImage" alt="User Name">
      </div>
      <div id="basic_info">
        <div class="thumb">
          <img :src="getImage(userImage)" @error="noImage" alt="User Name">
        </div>
        <div class="info">
          <p class="name">{{userName}}</p>
          <ul class="follow">
            <li>
              <strong class="item">フォロワー：</strong><span class="cnt">{{follower}}</span>
            </li>
            <li>
              <strong class="item">フォロー：</strong><span class="cnt">{{follow}}</span>
            </li>
          </ul>
        </div>
      </div>
      <div id="detail_info">
        {{detailText}}
        <strong class="attr" v-for="(attr, key) in attributeMap" :key="key">
          {{key}}：{{attr}}
        </strong>
      </div>
    </div>
  </div>
</template>

<script>
import {KG_STORAGE_KEY} from '../../../constants/App'
import * as App from '../../../utils/App'

export default {
  data () {
    return {
      userName: '',
      userImage: '',
      coverPhoto: '',
      follower: 0,
      follow: 0,
      detailText: '',
      attributeMap: {}
    }
  },
  methods: {
    getImage: function (image) {
      return App.getKagullResource(image)
    },
    noImage: function (element) {
      element.target.src = App.getKagullResource('noimage.svg')
    }
  },
  created: function () {
    let userInfo = App.getLocalStorage(KG_STORAGE_KEY.USER_INFO)
    if (userInfo != null && Object.keys(userInfo).length > 0) {
      this.userName = userInfo.userNickName
    }
    // TODO APIで必要な情報を取得する
    this.userImage = 'mypage_img2.jpg'
    this.coverPhoto = 'mypage_img1.jpg'
    this.follower = 128
    this.follow = 5
    this.detailText = 'ユーザーのプロフィールのテキスト'
    this.attributeMap = {'属性A': '◯◯◯◯◯◯', '属性B': '◯◯◯◯◯◯'}
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/addition.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/kagull/components/mypage/UserInfo.vue